import { useEffect, useState } from 'react';

import api from 'api';
import { getFormPath_v2 } from './getFormPath_v2';
import {
    parseHasSpouseFromPayload,
    parseSpouseUserIdFromPayload,
    persistSpouseLifecycle,
} from './hasSpouse';

export const useFormPath = (purpose: string, candidateID?: string | number, language?: string) => {
    const [formPath, setFormPath] = useState<string[]>([]);

    useEffect(() => {
        const listenForStorage = () => {
            const tempSpouseVal = JSON.parse(localStorage.getItem('hasSpouse') || 'false');
            const tempFamVal = JSON.parse(localStorage.getItem('hasFamily') || 'false');
            const tempFormPath2 = getFormPath_v2(purpose, tempSpouseVal, tempFamVal);
            setFormPath(tempFormPath2);
        };
        listenForStorage();
        window.addEventListener('storage', listenForStorage);

        const parsedId = Number(candidateID);
        const fetchId = Number.isFinite(parsedId) && parsedId > 0 ? parsedId : undefined;
        api.tableInput.fetchCandidateInput(
            (data: unknown) => {
                const flag = parseHasSpouseFromPayload(data);
                const spouseUserId = parseSpouseUserIdFromPayload(data);
                if (flag !== undefined || spouseUserId) {
                    persistSpouseLifecycle(flag, spouseUserId);
                }
            },
            'AdditionalDetails',
            fetchId,
            { asSelf: fetchId === undefined }
        );

        return () => {
            window.removeEventListener('storage', listenForStorage);
        };
    }, [purpose, candidateID, language]);

    return formPath;
};
